// Import Firebase SDK functions
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDN4Opd7Tx4dE42Z5Z3YK2jmU79DhFGanY",
  authDomain: "diamond-coin-8d8dc.firebaseapp.com",
  projectId: "diamond-coin-8d8dc",
  storageBucket: "diamond-coin-8d8dc.firebasestorage.app",
  messagingSenderId: "10142535009",
  appId: "1:10142535009:web:0dfff8afed124e929d4920",
  measurementId: "G-Q7BCHE5HQY"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// Initialize Auth and Firestore
export const auth = getAuth(app);
export const db = getFirestore(app);